export default "__VITE_ASSET__24138cef__"